import IntroStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/IntroStep';
import ProductCountStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/ProductCountStep';
import YesNoStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/YesNoStep';
import FoodServiceStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/FoodServiceStep';
import AdultBeverageStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/AdultBeverageStep';
import ProductGridQuestionStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/ProductGridQuestionStep';
import {
  RecommendationGridStep,
  RecommendationTemplateStep,
} from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/RecommendationStep';

import { STEP_TYPES } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepConstants';
/**
 * Step Component Registry
 * Maps step types to their corresponding components
 */
export const STEP_COMPONENTS = {
  [STEP_TYPES.INTRO]: IntroStep,
  [STEP_TYPES.INPUT]: ProductCountStep,
  [STEP_TYPES.YES_NO]: YesNoStep,
  [STEP_TYPES.FOOD_SERVICE]: FoodServiceStep,
  [STEP_TYPES.ADULT_BEVERAGE]: AdultBeverageStep,
  [STEP_TYPES.PRODUCT_GRID_QUESTION]: ProductGridQuestionStep,
  [STEP_TYPES.RECOMMENDATION_MORE_LESS_15_PRODUCTS]: RecommendationGridStep,
  [STEP_TYPES.RECOMMENDATION_MORE_THAN_15_PRODUCTS]: RecommendationTemplateStep,
};

export const getStepComponent = (type) => {
  const Component = STEP_COMPONENTS[type];

  if (!Component) {
    return null;
  }

  return Component;
};
